Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "EmptyList2808881963",
  {"root":"EmptyList2808881963--root","text":"EmptyList2808881963--text"},
  "",
  1,
  "EmptyList2808881963"
);

